const DefaultSmp = {};

export default DefaultSmp;
